import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ServiciosView from '../views/ServiciosView.vue';
import ProyectosView from '../views/ProyectosView.vue';
import AcercadeView from '../views/AcercadeView.vue';
import ClientesView from '../views/ClientesView.vue';
import ContactoView from '../views/ContactoView.vue';
import NosotrosView from '../views/NosotrosView.vue';

// 1. Define tus rutas
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/servicios',
    name: 'Servicios',
    component: ServiciosView
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: ClientesView
  },
  {
    path: '/proyectos',
    name: 'Proyectos',
    component: ProyectosView
  },
  {
    path: '/acerca',
    name: 'Acerca',
    component: AcercadeView
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: ContactoView
  },
  {
    path: '/nosotros',
    name: 'Nosotros',
    component: NosotrosView
  }
];

// 2. Crea la instancia del Router
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 3. Exporta para usarlo en la aplicación principal
export default router;